import React from 'react';

const CheckBox = ({ name, label, value, checked, onChange, error }) => {
  return (
    <label className={`checkbox-item ${error ? 'error' : ''}`} htmlFor={name}>
      <input
        type="checkbox"
        id={name}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  );
};

export default CheckBox;
